<!-- TESTIMONIAL SECTION START -->
<!-- <div class="section-full  p-t120 p-b90 testimonial-1-outer bg-white">
    <ng-template ngFor let-data [ngForOf]="data">
        <div class="container">
            <div class="section-content">
                <div class="row">
                    <div class="col-xl-6 col-lg-12 col-md-12">
                        
                        <div class="section-head left wt-small-separator-outer">
                            <div class="wt-small-separator site-text-primary">
                                <div class="sep-leaf-left"></div>
                                <div>{{data.title}}</div>
                            </div>
                            <h2 class="wt-title">{{data.subtitle}}</h2>
                        </div>
                       

                    </div>

                </div>

                <div class="testimonial-title-large">
                    <span>Testimonials</span>
                </div>
                <div class="testimonial-1-content owl-carousel">
                   
                    <div class="item" *ngFor="let item of data.testimonials">
                        <div class="testimonial-1 bg-white">
                            <div class="testimonial-content">
                                <div class="testimonial-detail clearfix">
                                    <div class="testimonial-pic-block">
                                        <div class="testimonial-pic">
                                            <img src="{{item.image}}" alt="">
                                        </div>
                                    </div>
                                    <div class="testimonial-info">
                                        <span class="testimonial-name">{{item.name}}</span>
                                        <span class="testimonial-position">{{item.designation}}</span>
                                    </div>
                                </div>

                                <div class="testimonial-text">
                                    <p>
                                        {{item.quote}}
                                    </p>
                                    <i class="flaticon-quote-1"></i>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </ng-template>
</div> -->
<!-- TESTIMONIAL SECTION END -->
<!-- <div class="section-full p-t10 p-b10 bg-white">
    <div class="container">
       
        <div class="section-head center wt-small-separator-outer text-center text-white">
            <div class="wt-small-separator site-text-secondry">
                <div class="sep-leaf-left"></div>
                <div>Welcome to Soul Space</div>
            </div>
            <h5>At Soul Space, we believe that mental wellness is not just the absence of illness but the presence of positive mental, emotional, and spiritual health. We are dedicated to offering holistic mental wellness services that address the whole person—mind, body, and soul.
                Our parent company, Stemz Global is a diversified conglomerate with a comprehensive portfolio that spans Visa Medical Services, Radiology & Diagnostic Services, Oncology Services, Integrated Healthcare Services, and AI-Assisted Diagnosis, Stemz Global is at the forefront of transforming healthcare delivery. Stemz Global is dedicated to advancing healthcare quality and accessibility, impacting lives globally.
            </h5>
        </div>
        </div>
        </div>

        <div class="section-full p-t10 p-b10 bg-white">
            <div class="container">
               
                <div class="section-head center wt-small-separator-outer text-center text-white">
                    <div class="wt-small-separator site-text-secondry">
                        <div class="sep-leaf-left"></div>
                        <div>Our Mission</div>
                    </div>
                    <h5>Our mission is to empower individuals to achieve a balanced and fulfilling life through comprehensive mental wellness services. We strive to create a space where everyone feels safe, supported, and guided on their journey toward inner peace and well-being.
                </h5>
                 
                </div>
                </div>
                </div>

                <div class="section-full p-t10 p-b10 bg-white">
                    <div class="container">
                       
                        <div class="section-head center wt-small-separator-outer text-center text-white">
                            <div class="wt-small-separator site-text-secondry">
                                <div class="sep-leaf-left"></div>
                                <div>Who are we?</div>
                            </div>
                            <h5>Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.
                        </h5>
                         
                        </div>
                        </div>
                        </div>

                        <div class="section-full p-t10 p-b10 bg-white">
                            <div class="container">
                                
                                <div class="section-head center wt-small-separator-outer text-center text-white">
                                    <div class="wt-small-separator site-text-secondry">
                                        <div class="sep-leaf-left"></div>
                                        <div>Why Choose Soul Space?</div>
                                    </div>
                                    <h5>
                                        <ul class="centered-list">
                                            <li>Personalized Care from experienced professionals</li>
                                            <li>Age-specific treatment plan</li>
                                            <li>Perfect blend of modern scientific treatments that are clinically proven</li>
                                            <li>Holistic Wellbeing - Mind, Body & Soul</li>
                                        </ul>
                                        
                                </h5>
                                 
                                </div>
                                </div>
                                </div>

                                <div class="section-full p-t10 p-b10 bg-white">
                                    <div class="container">
                                       
                                        <div class="section-head center wt-small-separator-outer text-center text-white">
                                            <div class="wt-small-separator site-text-secondry">
                                                <div class="sep-leaf-left"></div>
                                                <div>Embracing Mental Wellbeing in a Changing World</div>
                                            </div>
                                            <h5>
                                                
                                                    <P>The rapid technological advances of recent decades have profoundly impacted our individual and collective lifestyles. These changes necessitate a restructuring of our belief systems, urging us to place mental and emotional wellbeing on par with physical health, rather than viewing it as a distant corollary of “good physical health”.</P>
                                                    <P>In recent years, there has been a global shift in how we perceive wellbeing. India took a pioneering step in 2011 by attempting to put mental health on the WHO agenda when only non-communicable diseases were given importance. This effort culminated on May 2,2016, when the then UN Secretary General António Guterres launched mental health as a flagship program.</P>
                                                    <P>Soul Space was born from the global awakening, formed in December, 2023, we are a registered entity of dedicated mental health professionals united by a common cause: to bring the benefits of positive mental health and wellbeing to the general population.</P>
                                                    
                                                
                                                
                                        </h5>
                                         
                                        </div>
                                        </div>
                                        </div> -->
                                        <div class="section-full p-t40 p-b10 bg-white">
                                            <div class="container">
                                                <!-- TITLE START-->
                                                <div class="section-head wt-small-separator-outer text-left text-black">
                                                    <div class="wt-small-separator site-text-secondry">
                                                        <div class="sep-leaf-left"></div>
                                                        <div>Welcome to Soul Space</div>
                                                    </div>
                                                    <p>At Soul Space, we believe that mental wellness is not just the absence of illness but the presence of positive mental, emotional, and spiritual health. We are dedicated to offering holistic mental wellness services that address the whole person—mind, body, and soul. Our parent company, Stemz Global is a diversified conglomerate with a comprehensive portfolio that spans Visa Medical Services, Radiology & Diagnostic Services, Oncology Services, Integrated Healthcare Services, and AI-Assisted Diagnosis, Stemz Global is at the forefront of transforming healthcare delivery. Stemz Global is dedicated to advancing healthcare quality and accessibility, impacting lives globally.</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="section-full p-t10 p-b10 bg-white">
                                            <div class="container">
                                                <!-- TITLE START-->
                                                <div class="section-head wt-small-separator-outer text-left text-black">
                                                    <div class="wt-small-separator site-text-secondry">
                                                        <div class="sep-leaf-left"></div>
                                                        <div>Our Mission</div>
                                                    </div>
                                                    <p>Our mission is to empower individuals to achieve a balanced and fulfilling life through comprehensive mental wellness services. We strive to create a space where everyone feels safe, supported, and guided on their journey toward inner peace and well-being.</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="section-full p-t10 p-b10 bg-white">
                                            <div class="container">
                                                <!-- TITLE START-->
                                                <div class="section-head wt-small-separator-outer text-left text-black">
                                                    <div class="wt-small-separator site-text-secondry">
                                                        <div class="sep-leaf-left"></div>
                                                        <div>Who are we</div>
                                                    </div>
                                                    <p>Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="section-full p-t10 p-b10 bg-white">
                                            <div class="container">
                                                <!-- TITLE START-->
                                                <div class="section-head wt-small-separator-outer text-left text-black">
                                                    <div class="wt-small-separator site-text-secondry">
                                                        <div class="sep-leaf-left"></div>
                                                        <div>Why Choose Soul Space</div>
                                                    </div>
                                                   
                                                        <ul class="left-aligned-list">
                                                            <li>Personalized Care from experienced professionals</li>
                                                            <li>Age-specific treatment plan</li>
                                                            <li>Perfect blend of modern scientific treatments that are clinically proven</li>
                                                            <li>Holistic Wellbeing - Mind, Body & Soul</li>
                                                        </ul>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="section-full p-t10 p-b10 bg-white">
                                            <div class="container">
                                                <!-- TITLE START-->
                                                <div class="section-head wt-small-separator-outer text-left text-black">
                                                    <div class="wt-small-separator site-text-secondry">
                                                        <div class="sep-leaf-left"></div>
                                                        <div>Embracing Mental Wellbeing in a Changing World</div>
                                                    </div>
                                                   
                                                        <p>The rapid technological advances of recent decades have profoundly impacted our individual and collective lifestyles. These changes necessitate a restructuring of our belief systems, urging us to place mental and emotional wellbeing on par with physical health, rather than viewing it as a distant corollary of “good physical health”.</p>
                                                        <p>In recent years, there has been a global shift in how we perceive wellbeing. India took a pioneering step in 2011 by attempting to put mental health on the WHO agenda when only non-communicable diseases were given importance. This effort culminated on May 2, 2016, when the then UN Secretary General António Guterres launched mental health as a flagship program.</p>
                                                        <p>Soul Space was born from the global awakening, formed in December, 2023, we are a registered entity of dedicated mental health professionals united by a common cause: to bring the benefits of positive mental health and wellbeing to the general population.</p>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        